// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ****Fonts**** */
/* ****Shadows (subtle elevation — flat SaaS)**** */
/* ****Border radius**** */
/* ****icon size**** */
/* **** Device width **** */
/* **** helper variable **** */
/* **** Motion **** */
.Login_container__LdD3O {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  min-height: 100vh;
  padding: 2rem;
  background: radial-gradient(ellipse 80% 60% at 10% 20%, rgba(3, 105, 161, 0.12), transparent 55%), radial-gradient(ellipse 70% 50% at 90% 80%, rgba(15, 23, 42, 0.08), transparent 50%), linear-gradient(160deg, #f1f5f9 0%, #e2e8f0 45%, #f8fafc 100%);
}
.Login_container__LdD3O .Login_keyPic__37LfM {
  width: min(42vw, 520px);
  flex-shrink: 0;
  order: 2;
  animation: Login_fadeRise__gnO88 500ms cubic-bezier(0.16, 1, 0.3, 1) both;
}
.Login_container__LdD3O .Login_keyPic__37LfM img {
  width: 100%;
  height: auto;
  filter: drop-shadow(0 20px 40px rgba(15, 23, 42, 0.12));
}
@media screen and (max-width: 992px) {
  .Login_container__LdD3O .Login_keyPic__37LfM {
    display: none;
  }
}
.Login_container__LdD3O.Login_rtl__-bUJg {
  direction: rtl;
}

.Login_loginBox__JEUYo {
  background: var(--card-bgc);
  padding: 2.25rem 2rem 2rem;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-md);
  width: 100%;
  max-width: 420px;
  animation: Login_fadeRise__gnO88 400ms cubic-bezier(0.16, 1, 0.3, 1) both;
}
.Login_loginBox__JEUYo form button[type=submit] {
  width: 100%;
}

.Login_tabRow__rcwbQ {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  padding: 0.25rem;
  background: var(--surface-muted);
  border-radius: 8px;
}

.Login_tabBtn__iLzQ7 {
  flex: 1 1;
  min-height: 44px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9375rem;
  cursor: pointer;
  background: transparent;
  color: var(--text-muted);
  transition: background-color 150ms cubic-bezier(0.16, 1, 0.3, 1), color 150ms cubic-bezier(0.16, 1, 0.3, 1), box-shadow 150ms cubic-bezier(0.16, 1, 0.3, 1);
}
.Login_tabBtn__iLzQ7:hover:not(:disabled) {
  color: var(--text-color);
}
.Login_tabBtnActive__x3XXe {
  background: var(--secondaryColor);
  color: #ffffff;
  box-shadow: var(--shadow-sm);
}

.Login_logo__da2O3 {
  text-align: center;
  margin-bottom: 1rem;
}
.Login_logo__da2O3 img {
  max-width: 112px;
  height: auto;
  margin: 0 auto;
}

.Login_brand__xKXdu {
  text-align: center;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--primaryColor);
  margin-bottom: 0.75rem;
}

.Login_title__QDw91 {
  text-align: center;
  margin-bottom: 1.75rem;
  color: var(--text-color);
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.Login_passwordWrap__qPCwy {
  position: relative;
  width: 100%;
}

.Login_eyeBtn__NnrIN {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  border: none;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  border-radius: 6px;
  transition: color 150ms cubic-bezier(0.16, 1, 0.3, 1), background-color 150ms cubic-bezier(0.16, 1, 0.3, 1);
}
.Login_eyeBtn__NnrIN:hover {
  color: var(--text-color);
  background-color: var(--surface-muted);
}

.Login_errorMessage__7Y0aX {
  display: none;
  opacity: 0;
  color: var(--destructive);
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  margin: 0.25rem 0 0.75rem;
  transition: opacity 200ms cubic-bezier(0.16, 1, 0.3, 1);
}
.Login_errorMessage__7Y0aX.Login_visible__YWqOQ {
  display: block;
  opacity: 1;
}
.Login_errorMessage__7Y0aX.Login_shake__a2zUj {
  animation: Login_shake__a2zUj 0.45s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

.Login_checkbox__4CqFD {
  margin-top: 1.15rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  min-height: 44px;
}
.Login_checkbox__4CqFD input[type=checkbox] {
  width: 18px;
  height: 18px;
  accent-color: var(--primaryColor);
  cursor: pointer;
}
.Login_checkbox__4CqFD label {
  color: var(--text-muted);
  font-size: 0.875rem;
  cursor: pointer;
}

@keyframes Login_fadeRise__gnO88 {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes Login_shake__a2zUj {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .Login_loginBox__JEUYo,
  .Login_container__LdD3O .Login_keyPic__37LfM {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/login/Login.module.scss","webpack://./src/scss/abstracts/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,kBAAA;AAeA,mDAAA;AAIA,0BAAA;AAKA,sBAAA;AAIA,2BAAA;AAMA,8BAAA;AAOA,qBAAA;ADvCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,aAAA;EACA,uPACE;AAMJ;AAFE;EACE,uBAAA;EACA,cAAA;EACA,QAAA;EACA,yEAAA;AAIJ;AAFI;EACE,WAAA;EACA,YAAA;EACA,uDAAA;AAIN;AADI;EAZF;IAaI,aAAA;EAIJ;AACF;AADE;EACE,cAAA;AAGJ;;AACA;EACE,2BAAA;EACA,0BAAA;EACA,mBClBmB;EDmBnB,qCAAA;EACA,4BAAA;EACA,WAAA;EACA,gBAAA;EACA,yEAAA;AAEF;AACI;EACE,WAAA;AACN;;AAIA;EACE,aAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBCvCkB;ADsCpB;;AAIA;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,wBAAA;EACA,2JAAA;AADF;AAIE;EACE,wBAAA;AAFJ;AAKE;EACE,iCAAA;EACA,cAAA;EACA,4BAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,mBAAA;AAJF;AAME;EACE,gBAAA;EACA,YAAA;EACA,cAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;EACA,sBAAA;AALF;;AAQA;EACE,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AALF;;AAQA;EACE,kBAAA;EACA,WAAA;AALF;;AAQA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,2GAAA;AALF;AAOE;EACE,wBAAA;EACA,sCAAA;AALJ;;AASA;EACE,aAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uDAAA;AANF;AAQE;EACE,cAAA;EACA,UAAA;AANJ;AASE;EACE,6EAAA;AAPJ;;AAWA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AARF;AAUE;EACE,WAAA;EACA,YAAA;EACA,iCAAA;EACA,eAAA;AARJ;AAWE;EACE,wBAAA;EACA,mBAAA;EACA,eAAA;AATJ;;AAaA;EACE;IACE,UAAA;IACA,2BAAA;EAVF;EAYA;IACE,UAAA;IACA,wBAAA;EAVF;AACF;AAaA;EACE;IAEE,kCAAA;EAZF;EAcA;IAEE,iCAAA;EAbF;EAeA;IAGE,kCAAA;EAfF;EAiBA;IAEE,iCAAA;EAhBF;AACF;AAmBA;EACE;;IAEE,eAAA;EAjBF;AACF","sourcesContent":["@use \"../../scss/abstracts/\" as *;\r\n\r\n.container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 3rem;\r\n  min-height: 100vh;\r\n  padding: 2rem;\r\n  background:\r\n    radial-gradient(ellipse 80% 60% at 10% 20%, rgba(3, 105, 161, 0.12), transparent 55%),\r\n    radial-gradient(ellipse 70% 50% at 90% 80%, rgba(15, 23, 42, 0.08), transparent 50%),\r\n    linear-gradient(160deg, #f1f5f9 0%, #e2e8f0 45%, #f8fafc 100%);\r\n\r\n  .keyPic {\r\n    width: min(42vw, 520px);\r\n    flex-shrink: 0;\r\n    order: 2;\r\n    animation: fadeRise 500ms $ease-out both;\r\n\r\n    img {\r\n      width: 100%;\r\n      height: auto;\r\n      filter: drop-shadow(0 20px 40px rgba(15, 23, 42, 0.12));\r\n    }\r\n\r\n    @media screen and (max-width: 992px) {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  &.rtl {\r\n    direction: rtl;\r\n  }\r\n}\r\n\r\n.loginBox {\r\n  background: var(--card-bgc);\r\n  padding: 2.25rem 2rem 2rem;\r\n  border-radius: $mediumBorderRadius;\r\n  border: 1px solid var(--border-color);\r\n  box-shadow: var(--shadow-md);\r\n  width: 100%;\r\n  max-width: 420px;\r\n  animation: fadeRise 400ms $ease-out both;\r\n\r\n  form {\r\n    button[type=\"submit\"] {\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n.tabRow {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  margin-bottom: 1.5rem;\r\n  padding: 0.25rem;\r\n  background: var(--surface-muted);\r\n  border-radius: $smallBorderRadius;\r\n}\r\n\r\n.tabBtn {\r\n  flex: 1;\r\n  min-height: 44px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  font-size: 0.9375rem;\r\n  cursor: pointer;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  transition: background-color $duration-fast $ease-out, color $duration-fast $ease-out,\r\n    box-shadow $duration-fast $ease-out;\r\n\r\n  &:hover:not(:disabled) {\r\n    color: var(--text-color);\r\n  }\r\n\r\n  &Active {\r\n    background: var(--secondaryColor);\r\n    color: #ffffff;\r\n    box-shadow: var(--shadow-sm);\r\n  }\r\n}\r\n\r\n.logo {\r\n  text-align: center;\r\n  margin-bottom: 1rem;\r\n\r\n  img {\r\n    max-width: 112px;\r\n    height: auto;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.brand {\r\n  text-align: center;\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.14em;\r\n  text-transform: uppercase;\r\n  color: var(--primaryColor);\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.title {\r\n  text-align: center;\r\n  margin-bottom: 1.75rem;\r\n  color: var(--text-color);\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  letter-spacing: -0.02em;\r\n  line-height: 1.25;\r\n}\r\n\r\n.passwordWrap {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.eyeBtn {\r\n  position: absolute;\r\n  right: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 40px;\r\n  min-height: 40px;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n  border-radius: 6px;\r\n  transition: color $duration-fast $ease-out, background-color $duration-fast $ease-out;\r\n\r\n  &:hover {\r\n    color: var(--text-color);\r\n    background-color: var(--surface-muted);\r\n  }\r\n}\r\n\r\n.errorMessage {\r\n  display: none;\r\n  opacity: 0;\r\n  color: var(--destructive);\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  text-align: center;\r\n  margin: 0.25rem 0 0.75rem;\r\n  transition: opacity $duration-base $ease-out;\r\n\r\n  &.visible {\r\n    display: block;\r\n    opacity: 1;\r\n  }\r\n\r\n  &.shake {\r\n    animation: shake 0.45s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\r\n  }\r\n}\r\n\r\n.checkbox {\r\n  margin-top: 1.15rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  min-height: 44px;\r\n\r\n  input[type=\"checkbox\"] {\r\n    width: 18px;\r\n    height: 18px;\r\n    accent-color: var(--primaryColor);\r\n    cursor: pointer;\r\n  }\r\n\r\n  label {\r\n    color: var(--text-muted);\r\n    font-size: 0.875rem;\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n@keyframes fadeRise {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(12px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes shake {\r\n  10%,\r\n  90% {\r\n    transform: translate3d(-1px, 0, 0);\r\n  }\r\n  20%,\r\n  80% {\r\n    transform: translate3d(2px, 0, 0);\r\n  }\r\n  30%,\r\n  50%,\r\n  70% {\r\n    transform: translate3d(-4px, 0, 0);\r\n  }\r\n  40%,\r\n  60% {\r\n    transform: translate3d(4px, 0, 0);\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .loginBox,\r\n  .container .keyPic {\r\n    animation: none;\r\n  }\r\n}\r\n","/* ****Fonts**** */\r\n\r\n//Body size\r\n$fontSizeBodySmall: 12px;\r\n$fontSizeBodyMedium: 14px;\r\n$fontSizeBodyLarge: 16px;\r\n//Headline size\r\n$fontSizeHeadlineSmall: 24px;\r\n$fontSizeHeadlineMedium: 36px;\r\n$fontSizeHeadlineLarge: 48px;\r\n//Display size\r\n$fontSizeDisplaySmall: 56px;\r\n//helper font size\r\n$fontSizeTableStatus: 11px;\r\n\r\n/* ****Shadows (subtle elevation — flat SaaS)**** */\r\n$mainBoxShadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);\r\n$secondBoxShadow: 0 12px 40px rgba(15, 23, 42, 0.18);\r\n\r\n/* ****Border radius**** */\r\n$smallBorderRadius: 8px;\r\n$mediumBorderRadius: 12px;\r\n$largeBorderRadius: 16px;\r\n\r\n/* ****icon size**** */\r\n$smallIconSize: 20px;\r\n$largeIconSize: 48px;\r\n\r\n/* **** Device width **** */\r\n$mobile-width: 576px;\r\n$tablet-width: 768px;\r\n$desktop-width: 992px;\r\n$largeDesktop-width: 1200px;\r\n\r\n/* **** helper variable **** */\r\n$sideBarOpenWidth: 248px;\r\n$sideBarCloseWidth: 72px;\r\n$spacing: 60px;\r\n$mobileSpacing: 16px;\r\n$sideBarLogoHeight: 171px;\r\n\r\n/* **** Motion **** */\r\n$ease-out: cubic-bezier(0.16, 1, 0.3, 1);\r\n$duration-fast: 150ms;\r\n$duration-base: 200ms;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Login_container__LdD3O`,
	"keyPic": `Login_keyPic__37LfM`,
	"fadeRise": `Login_fadeRise__gnO88`,
	"rtl": `Login_rtl__-bUJg`,
	"loginBox": `Login_loginBox__JEUYo`,
	"tabRow": `Login_tabRow__rcwbQ`,
	"tabBtn": `Login_tabBtn__iLzQ7`,
	"tabBtnActive": `Login_tabBtnActive__x3XXe`,
	"logo": `Login_logo__da2O3`,
	"brand": `Login_brand__xKXdu`,
	"title": `Login_title__QDw91`,
	"passwordWrap": `Login_passwordWrap__qPCwy`,
	"eyeBtn": `Login_eyeBtn__NnrIN`,
	"errorMessage": `Login_errorMessage__7Y0aX`,
	"visible": `Login_visible__YWqOQ`,
	"shake": `Login_shake__a2zUj`,
	"checkbox": `Login_checkbox__4CqFD`
};
export default ___CSS_LOADER_EXPORT___;
